// GENERATED CODE - DO NOT EDIT
// All valid modes of delivery
export const ModeTypeMap = {
    PICKUP: 'PICKUP',
    COURIER: 'COURIER',
    MAIL: 'MAIL',
};
//# sourceMappingURL=mode_type.js.map